import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SharedModule } from '../shared.module';
import { map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

const _log = false;

@Injectable({providedIn: 'root'})
export class MockAPIProvider {

	public data: any;

	constructor(
		public httpClient: HttpClient
	) {
	}

	/**
	 * load file from path
	 * @param file 
	 * @param cache: if requested with cache true, it will store in "session" 
	 * 
	 * //example usage
	 * this.something$ = this._mockAPIProvider.load('something.json', false)
			.pipe(map((res: Something[]) => {
				if(res && res.length > 0) {
					return res;
				}
				return null;
			}));
	 */
	public load(file: string, cache:boolean = false): Observable<any>{

		if (this.data && cache) {
			if(_log) console.log('found data already, load cached');
			return of(this.data);
		}

		if(_log) console.log('MockAPIProvider.load: assets/data/' + file);

		return this.httpClient
			.get('assets/data/' + file)
			.pipe(map((data) => {
				if(_log) console.log('MockAPIProvider.file', file, 'data:', data);
				this.data = data;
                return this.data;
			}));
	}




    /**
	 * load file from path
	 * @param file 
	 * @param cache: if requested with cache true, it will store in "session" 
	 * 
	 * //example usage
	 * this._MockAPIProvider.load('api-getlocation.json', false)
			.then((data) => {
				console.log('data:', data);
			})
			.catch(error => { console.log(error); });
	 */
    public loadPromise(file: string, cache:boolean = false) {

		if (this.data && cache) {
			if(_log) console.log('found data already, load cached');
			return Promise.resolve(this.data);
		}

		return new Promise(resolve => {
			if(_log) console.log('did not find data, load from source: ' + file);
			this.httpClient
				.get('assets/data/' + file)
				.subscribe(data => {
					this.data = data;//store for later
					//console.log('MockAPIProvider.data: ', data);
					resolve(this.data);
				});
		});
	}

}